module.exports = __webpack_public_path__ + "static/img/bg.37c7634.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/bg.png
// module id = SYZn
// module chunks = 1